export const pageGetInit = s => s.pageModal.get('pageInit');
export const pageGetLoading = s => s.pageModal.get('pageLoading');
export const pageGetData = s => s.pageModal.get('page').toJS();
